import { render, staticRenderFns } from "./FightSimulator.vue?vue&type=template&id=a0a0a854&scoped=true&"
import script from "./FightSimulator.vue?vue&type=script&lang=js&"
export * from "./FightSimulator.vue?vue&type=script&lang=js&"
import style0 from "./FightSimulator.vue?vue&type=style&index=0&id=a0a0a854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a0a854",
  null
  
)

export default component.exports